import classNames from "classnames";
import React, {
    HTMLAttributes,
    ReactNode,
    JSX,
} from "react";
import Styles from "./Text.module.scss";

type AsProp = keyof JSX.IntrinsicElements;

export type ColorVariant = "body-primary" | "body-secondary" | "text-link" | "text-title" | "danger" | "success" | "dim";

export interface LabelProps extends HTMLAttributes<HTMLDivElement> {
    as?: AsProp;

    textVariant?: "caption-small"
    | "caption-regular"
    | "caption-medium"
    | "caption-semibold"
    | "body-1-regular"
    | "body-1-medium"
    | "body-1-semibold"
    | "body-2-regular"
    | "body-2-medium"
    | "body-2-semibold"
    | "subtitle-1"
    | "subtitle-2"
    | "subtitle-3"
    | "title";

    colorVariant?: ColorVariant;
}

const Text = React.forwardRef((
    args: LabelProps,
    ref: React.ForwardedRef<HTMLElement>,
): ReactNode => {
    const {
        children,
        className,
        textVariant,
        colorVariant,
        as: asType,
        ...rest
    } = args;

    const ParentComponent = (asType ?? "div") as React.ElementType;

    return (
        <ParentComponent
            ref={ref}
            className={classNames(
                Styles.label,
                Styles[`text-${textVariant}`],
                Styles[`color-${colorVariant}`],
                className,
            )}
            {...rest}
        >
            {children}
        </ParentComponent>
    );
});
Text.defaultProps = {
    as: "div",
    textVariant: "body-1-regular",
    colorVariant: "body-primary",

};

export default Text;
